<template lang="pug">
form(@submit.prevent="questionar")
  modal(:active="true", title="Dúvida", @close="close", v-if="current")
    div(slot="modal-body")
      .form-group
        label.form-label(for="descricao") Dúvida sobre o documento {{ current.numero }}/{{ current.ano }}
        textarea#descricao.form-input(
          v-model="questionamento.descricao",
          rows="5",
          placeholder="Descreva sua dúvida sobre o documento"
        )
    div(slot="modal-footer")
      a.btn.btn-link.text-error(@click="close")
        i.fa.fa-close
        |
        | Cancelar
      button.btn.btn-primary(
        :disabled="!questionamento.descricao",
        :class="{ loading }"
      )
        i.fa.fa-check
        |
        | Confirmar
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors";

export default {
  vuex: {
    docs: {
      state: ["current"],
      actions: ["fetchQuestionar"],
    },
  },
  data() {
    return { questionamento: { descricao: "" }, loading: false };
  },
  methods: {
    close() {
      this.$router.back();
    },
    async questionar() {
      try {
        this.loading = true;
        await this.fetchQuestionar(this.questionamento);
        this.$toaster.success("Questionamento enviado para o fiscal");
        this.close();
      } catch (e) {
        toastErrors([e]);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
